import AppRoutes from "./routes";

export default function App() {
return <div className="h-lvh landscape:h-[100lvw] ~bg-zinc-900 md:w-1/2 lg:w-1/3 landscape:w-2/3 ~text-zinc-300 mx-6">
    <AppRoutes />
  </div>
}
